import React from 'react';
import { motion } from 'framer-motion';
import Img from '@/components/shared/Img';

export default function AlternatingSection({ eyebrow, title, text, quote, image, imageAlt, imageRight = true, contain = false }) {
  const imageBlock = (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.8 }}
      className="relative"
    >
      <div className="relative overflow-hidden rounded-sm">
        <Img
          src={image}
          alt={imageAlt}
          className={`w-full h-[350px] md:h-[450px] ${contain ? 'object-contain bg-[#111]' : 'object-cover object-center'}`}
          sizes="(min-width: 1024px) 46vw, calc(100vw - 2.5rem)"
        />
        {/* White corner accent */}
        <div className={`absolute ${imageRight ? 'bottom-0 left-0' : 'bottom-0 right-0'} w-20 h-20`}>
          <div className={`absolute bottom-0 ${imageRight ? 'left-0' : 'right-0'} w-full h-px bg-[#C97B2E]`} />
          <div className={`absolute bottom-0 ${imageRight ? 'left-0' : 'right-0'} w-px h-full bg-[#C97B2E]`} />
        </div>
      </div>
    </motion.div>
  );

  const textBlock = (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.7, delay: 0.1 }}
      className="flex flex-col justify-center"
    >
      {eyebrow && (
        <span className="font-body text-[#C97B2E] text-xs font-bold uppercase tracking-[0.3em] mb-4">
          {eyebrow}
        </span>
      )}
      <h3 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-6 leading-tight">
        {title}
      </h3>
      <p className="font-body text-white/60 text-base md:text-lg leading-relaxed mb-6">
        {text}
      </p>
      {quote && (
        <blockquote className="border-l-4 border-[#C97B2E] pl-5 italic font-heading text-white/70 text-lg">
          {quote}
        </blockquote>
      )}
    </motion.div>
  );

  return (
    <section className="relative py-20 md:py-28 bg-[#0a0a0a]">
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {imageRight ? (
            <>
              {textBlock}
              {imageBlock}
            </>
          ) : (
            <>
              {imageBlock}
              {textBlock}
            </>
          )}
        </div>
      </div>
    </section>
  );
}